<template>
  <tr
    ref="tableTr"
    :class="[
      `tr-table-state-${state}`,
      {
        'is-selected': isSelected,
        selected: data,
        'is-expand': maxHeight != '0px',
        activeEdit: activeEdit,
        hoverFlat: $parent.hoverFlat,
      },
    ]"
    class="tr-values vs-table--tr"
    @click="clicktr"
    @dblclick="dblclicktr">
    <!-- Keyed off the table, not this row's own slot: the header th follows
         hasCheckColumn, so a row without an expand slot in a table that has one
         would otherwise come out a column short. -->
    <td v-if="$parent.hasCheckColumn" :class="{ 'active-expanded': expanded }" class="td-check">
      <vs-checkbox v-if="$parent.multiple" :checked="isSelected" size="small" @change="handleCheckbox" />

      <vs-icon v-if="$slots.expand">keyboard_arrow_down</vs-icon>
    </td>
    <slot></slot>
  </tr>
</template>
<script>
import Vue from "vue"
import trExpand from "./UITrExpand.vue"
export default {
  name: "UITr",
  props: {
    state: {
      type: String,
      default: null,
    },
    data: {
      default: null,
    },
    closable: {
      type: Boolean,
      default: false,
    },
    // Asked before a click collapses an open row, so a consumer whose expand slot
    // holds unsaved input can veto it. Resolve false to keep the row open.
    beforeCollapse: {
      type: Function,
      default: null,
    },
  },
  data: () => ({
    colspan: 0,
    expanded: false,
    maxHeight: "0px",
    activeEdit: false,
  }),
  computed: {
    styleExpand() {
      return {
        maxHeight: this.maxHeight,
      }
    },
    isSelected() {
      if (this.$parent.multiple && this.$parent.value) {
        return this.data ? this.$parent.value.some((item) => JSON.stringify(item) === JSON.stringify(this.data)) : false
      } else {
        return this.data ? this.$parent.value == this.data : false
      }
    },
  },
  watch: {
    "$parent.datax"() {
      this.collapseExpandedData()
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this._isDestroyed) return
      // getThs counts the consumer's columns; the table prepends one more for
      // the checkbox / expand affordance.
      this.colspan = this.$parent.getThs() + (this.$parent.hasCheckColumn ? 1 : 0)
    })
  },
  created() {
    // Held here rather than on data(): the expand row is hand-mounted outside the
    // vdom, so it needs to be reachable, never reactive.
    this.expandInstance = null

    if (this.$slots.expand) this.$parent.hasExpadableData = true
  },
  beforeDestroy() {
    // Nothing else collapses a destroyed row: the $parent.datax watcher is torn
    // down by $destroy before it can run, and the hand-mounted expand row is
    // absent from _vnode, so the patch that removes this row leaves it behind.
    this.collapseExpandedData()
  },
  methods: {
    handleCheckbox() {
      this.$parent.handleCheckbox(this.data)
    },
    insertAfter(e, i) {
      if (e.nextSibling) {
        e.parentNode.insertBefore(i, e.nextSibling)
      } else {
        e.parentNode.appendChild(i)
      }
    },
    async clicktr(evt) {
      this.$parent.clicktr(this.data, true)

      if (this.$slots.expand) {
        await this.clicktd(evt)
      }
    },
    dblclicktr() {
      this.$parent.dblclicktr(this.data, true)
    },
    async clicktd(evt) {
      if (this.$parent.multiple || !this.$slots.expand) return

      if (this.expanded) {
        await this.requestCollapse()
        return
      }

      const tr = evt.target.closest("tr")
      tr.classList.add("tr-expandedx")

      const trx = Vue.extend(trExpand)
      const instance = new trx({ parent: this, propsData: { close: this.closable, colspan: this.colspan } })
      instance.$slots.default = this.$slots.expand
      instance.$on("click", this.requestCollapse)
      instance.$mount()

      this.insertAfter(tr, instance.$el)
      this.expandInstance = instance
      this.expanded = true
    },
    async requestCollapse() {
      if (this.beforeCollapse && !(await this.beforeCollapse())) return

      this.collapseExpandedData()
    },

    collapseExpandedData() {
      if (!this.expanded) return

      const instance = this.expandInstance
      // Read now, not at insert time: until UITrExpand's own mounted() flips its
      // v-if, $el is still the placeholder comment. Going through the instance
      // also beats nextSibling, which by here can be a row a re-sort moved in.
      const expandRow = instance && instance.$el

      if (expandRow && expandRow.parentNode) {
        expandRow.parentNode.removeChild(expandRow)
      }

      if (instance) {
        instance.$destroy()
      }

      this.expandInstance = null
      this.expanded = false

      if (this.$refs.tableTr) {
        this.$refs.tableTr.classList.remove("tr-expandedx")
      }
    },
  },
}
</script>
